import React from 'react';
import styled from 'styled-components';
import {
  OnQuickReportsChanged,
  QueryModel,
  SortModel
} from '../../../../utils/DataTableQueryProvider/DataTableQuery.types';
import { DataTableExportActions } from '../toolbar/DataTableExportActions';

interface Props<Q extends QueryModel, S extends SortModel> {
  report: OnQuickReportsChanged<Q, S>;
  onOpen: (() => void) | undefined;
  ExportDialogProps?: { children?: React.ReactNode };
  ScheduleExportDialogProps?: { children?: React.ReactNode };
}

export const ExportPanelActions = <Q extends QueryModel, S extends SortModel>({
  onOpen,
  report,
  ScheduleExportDialogProps,
  ExportDialogProps
}: Props<Q, S>) => (
  <StyledExportButton>
    <DataTableExportActions
      source="quick-report-panel"
      onOpen={onOpen}
      report={report}
      ScheduleExportDialogProps={ScheduleExportDialogProps}
      ExportDialogProps={ExportDialogProps}
    />
  </StyledExportButton>
);

const StyledExportButton = styled.div`
  display: inline-block;
`;
